import { BAA_EVENT } from './baaApi';

// Opens the BAA window whenever any request is blocked with BAA_REQUIRED.
export const installBaaWatcher = () => {
  const fire = () => window.dispatchEvent(new Event(BAA_EVENT));
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (...args) {
    this.addEventListener('load', () => {
      if (this.status === 403 && String(this.responseText || '').includes('"BAA_REQUIRED"')) fire();
    });
    return origOpen.apply(this, args);
  };
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await origFetch(...args);
    if (res.status === 403) {
      res.clone().text().then((t) => t.includes('"BAA_REQUIRED"') && fire()).catch(() => {});
    }
    return res;
  };
};
